const SyncPhrmActualsApi = async (planId) => {
  try {
    console.log('SyncPhrmActualsApi - Syncing PHRM actuals for planId:', planId);
    
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/${planId}/sync-phrm-actuals`,
      requestOptions
    );

    const data = await response.json();
    console.log('SyncPhrmActualsApi - Response:', data);
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to sync PHRM actuals');
    }
    
    return data;
  } catch (error) {
    console.error('SyncPhrmActualsApi - Error:', error);
    throw error;
  }
};

export default SyncPhrmActualsApi;
